export const buildLeadData = (data) => ({
    FirstName: data.Applicant.FirstName,
    LastName: data.Applicant.LastName,
    Email: data.Applicant.Email,
    Phone: data.Applicant.PhoneNumber,
    Address: data.Applicant.Address.StreetAddress1,
    Address2: data.Applicant.Address.StreetAddress2,
    City: data.Applicant.Address.City,
    State: data.Applicant.Address.State,
    Zip: data.Applicant.Address.Zip,
    VehicleType: data.Vehicle.VehicleType,
    VehicleYear: data.Vehicle.Year,
    VehicleMake: data.Vehicle.Brand,
    VehicleModel: data.Vehicle.Model,
    Ssn: data.Applicant.TaxID,
    Dob: data.Applicant.DateOfBirth,
    Housing: data.Applicant.Address.ResidenceType,
    HousingAmount: data.Applicant.Address.MonthlyRent,
    HousingLength: data.Applicant.Address.DurationYears,
    Employer: data.Applicant.Employment.EmployerName,
    Occupation: data.Applicant.Employment.JobTitle,
    WorkPhone: data.Applicant.Employment.EmployerPhoneNumber,
    Tenure: data.Applicant.Employment.DurationYears,
    PreviousTenure: data.Applicant.PrevEmployment?.DurationYears,
    Salary: data.Applicant.Employment.IncomeAmount,
    PreviousEmployer: data.Applicant.PrevEmployment?.EmployerName,
    PreviousOccupation: data.Applicant.PrevEmployment?.JobTitle,
    CoAppFirstName: data.CoApplicant?.FirstName,
    CoAppLastName: data.CoApplicant?.LastName,
    CoAppEmail: data.CoApplicant?.Email,
    CoAppPhone: data.CoApplicant?.PhoneNumber,
    CoAppSsn: data.CoApplicant?.TaxID,
    CoAppDob: data.CoApplicant?.DateOfBirth,
    CoAppHousing: data.CoApplicant?.Address.ResidenceType,
    CoAppHousingAmount: data.CoApplicant?.Address.MonthlyRent,
    CoAppHousingLength: data.CoApplicant?.Address.DurationYears,
    CoAppAddress: data.CoApplicant?.Address.StreetAddress1,
    CoAppAddress2: data.CoApplicant?.Address.StreetAddress2,
    CoAppCity: data.CoApplicant?.Address.City,
    CoAppState: data.CoApplicant?.Address.State,
    CoAppZip: data.CoApplicant?.Address.Zip,
    CoAppEmployer: data.CoApplicant?.Employment.EmployerName,
    CoAppWorkPhone: data.CoApplicant?.Employment.EmployerPhoneNumber,
    CoAppOccupation: data.CoApplicant?.Employment.JobTitle,
    CoAppTenure: data.CoApplicant?.Employment.DurationYears,
    CoAppPreviousTenure: data.CoApplicant?.PrevEmployment?.DurationYears,
    CoAppSalary: data.CoApplicant?.Employment.IncomeAmount,
    CoAppPreviousEmployer: data.CoApplicant?.PrevEmployment?.EmployerName,
    CoAppPreviousOccupation: data.CoApplicant?.PrevEmployment?.JobTitle,
});
